import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'v2m-blog-brose',
  templateUrl: './blog-brose.component.html',
  styleUrls: ['./blog-brose.component.scss']
})
export class BlogBroseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
